import * as Yup from 'yup';

export const editGenieAssistantsYupValidation = () => {
  return Yup.object().shape({
    activeAllAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
  });
};
